module.exports = __webpack_public_path__ + "img/asset_LARIX.a01aa4ff.svg";